import React, {Component} from "react";
import {
    Button,
    FormFeedback,
    FormGroup,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Table
} from "reactstrap";
import AddButton from "../AddButton/AddButton";
import ConfirmDialog from "../ConfirmDialog/ConfirmDialog";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Dropdown from "../Dropdown/Dropdown";
import AuthorizationService from "../../services/authorization-service";

/**
 * Input properties:
 * <ul>
 * <li>list:  The initial state of the list to be managed.  Each item in list should be an object with name, value and optionally type.</li>
 * <li>editHandler: Required The name of the function to be called to handle the addition or removal.  It will expect a new list to be passed.</li>
 * <li>includeType: whether a type attribute should be included.</li>
 * <li>type: A name for the type, e.g. Role, Environment, Attribute</li>
 * <li>auth: Auth object for checking add and remove permissions</li>
 * </ul>
 */
export default class ListHandler extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            isAddItemModalVisible: false,
            deleteItem: {},
            newItemName: "",
            newItemType: "Text",
            validName: true
        }
    }

    addItem = () => {
        this.setState({
            isAddItemModalVisible: true
        });
    };

    deleteItem = () => {
        let list = this.props.list.filter(item => item.name !== this.state.deleteItem.name);
        this.props.editHandler(list);
        this.setState({isDeleteRoleModalVisible: false});
    }


    hideModal = () => {
        this.setState({
            isAddItemModalVisible: false
        });
    };

    addAction = function () {
        let list = [];
        if (this.props.list) list = [...this.props.list];

        let item = {
            name: this.state.newField
        }
        if (this.props.includeType === "true") {
            item.type = this.state.newItemType;
        }
        list.push(item);
        this.props.editHandler(list);
        this.setState({
            isAddItemModalVisible: false,
            newItemType: "Text"
        });
    }

    //Validate the input into the field, updating the local state and checking against the names in the existing list to ensure uniqueness
    validateValue = (e) => {
        let valid = true;
        if (this.props.list.find(p => p.name === e.target.value)) {
            valid = false;
        }
        this.setState({
            newField: e.target.value,
            validName: valid
        })
    }

    selectOption = selectedOption => {
        this.setState({newItemType: selectedOption});
    };

    render() {
        return (
            <div className="user-product-roles">
                {AuthorizationService.hasPermission(this.props.permission) && (
                    <AddButton
                        name={`ADD ${this.props.type}`}
                        handleCreateDialogToggle={this.addItem}
                        className="btn-add"
                    />
                )}

                {/* Add Item */}
                <Modal isOpen={this.state.isAddItemModalVisible} size="lg">
                    {!this.state.isDialogLoading ? (
                        <ModalHeader
                            toggle={() => {
                                this.hideModal();
                            }}
                        >
                            {`ADD ${this.props.type}`}
                        </ModalHeader>
                    ) : (
                        <ModalHeader>{`ADD ${this.props.type}`}</ModalHeader>
                    )}

                    {!this.state.isDialogLoading && (
                        <ModalBody>

                            <FormGroup className="custom_form">
                                {(
                                    <Label for="name">Name</Label>
                                )}
                                <Input
                                    name="name"
                                    id="value"
                                    placeholder="Name"
                                    value={this.state.newValue}
                                    onChange={e => this.validateValue(e)}
                                    autoComplete="off"
                                    invalid={!this.state.validName}
                                    valid={this.state.validName}
                                />
                                <FormFeedback valid={this.state.validName}>
                                    {this.state.validName !== true ? "Name is duplicate of another name" : ""}
                                </FormFeedback>
                            </FormGroup>
                            {this.props.includeType === "true" && (
                                <FormGroup className="custom_form">
                                    <Dropdown
                                        options={["Text", "Boolean", "Number"]}
                                        changeSelectedOption={this.selectOption}
                                        defaultValue={"Text"}
                                    />
                                </FormGroup>
                            )}


                        </ModalBody>
                    )}
                    <ModalFooter>
                        <Button
                            color="btn btn-link"
                            onClick={() => {
                                this.hideModal();
                            }}
                        >Cancel</Button>
                        <button
                            type="button"
                            className="btn btn-success submit-user-button"
                            disabled={!this.state.validName}
                            onClick={() => {
                                this.addAction();
                            }}
                        >Save
                        </button>
                    </ModalFooter>
                </Modal>


                {/* Delete account product */}
                <ConfirmDialog
                    toggleState={this.state.isDeleteRoleModalVisible}
                    cancelAction={() =>
                        this.setState({isDeleteRoleModalVisible: false})
                    }
                    message={`Are you sure you want to  ${
                        this.state.deleteItem.name
                    }?`}
                    confirmAction={() => this.deleteItem()}
                    confirmActionName="Remove"
                    confirmClassName={"btn-warning"}
                    caption="Remove Role"
                    isLoading={this.state.isDialogLoading}
                />

                <Table>
                    <thead>
                    <tr>
                        <th className="width-20">NAME</th>
                        {this.props.includeType === "true" &&
                        <th className="width-20">TYPE</th>
                        }
                        <th className={`${AuthorizationService.hasPermission(this.props.permission) && this.props.isActive ? "width-5" : ""}`}>
                            {AuthorizationService.hasPermission(this.props.permission) && this.props.isActive ? "REMOVE" : ""}
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.props.list.length > 0
                    && this.props.list.map((item, i) => {
                        return (
                            <tr key={i}>
                                <td className="width-20">{item.name}</td>

                                {this.props.includeType === "true" && <td className="width-80">{item.type}</td>}
                                <td className={`${this.props.isActive ? "width-5" : ""}`}>
                                    {AuthorizationService.hasPermission(this.props.permission) && (
                                        <FontAwesomeIcon
                                            className="fas delete-icon"
                                            icon="times"
                                            size="sm"
                                            color="#59595B"
                                            onClick={() => {
                                                this.setState({
                                                    isDeleteRoleModalVisible: true,
                                                    deleteItem: item
                                                });
                                            }}
                                        />
                                    )}
                                </td>
                            </tr>
                        );
                    })
                    }
                    </tbody>
                </Table>
                {this.props.list.length === 0 &&
                <p className="no-attributes">No item defined.</p>}

            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/common/ListHandler/ListHandler.js